import { render, staticRenderFns } from "./RefundFailRecord.vue?vue&type=template&id=25876556&scoped=true"
import script from "./RefundFailRecord.vue?vue&type=script&lang=js"
export * from "./RefundFailRecord.vue?vue&type=script&lang=js"
import style0 from "./RefundFailRecord.vue?vue&type=style&index=0&id=25876556&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25876556",
  null
  
)

export default component.exports